module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.value) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.firstName),
      expression: "value.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "firstName",
      "required": "",
      "id": "firstName",
      "placeholder": "First Name",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.value.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "firstName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.lastName),
      expression: "value.lastName"
    }],
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "name": "lastName",
      "required": "",
      "id": "lastName",
      "placeholder": "Last Name",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.value.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "lastName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Username")]), _vm._v(" "), (_vm.mode === 'edit') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.username),
      expression: "value.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "required": "",
      "id": "username",
      "placeholder": "Username",
      "tabindex": "3"
    },
    domProps: {
      "value": (_vm.value.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "username", $event.target.value)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.userName),
      expression: "value.userName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": "",
      "id": "username",
      "placeholder": "Username",
      "tabindex": "3"
    },
    domProps: {
      "value": (_vm.value.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "userName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "userGroup"
    }
  }, [_vm._v("User Group(s)")]), _vm._v(" "), _c('vue-tags-input', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "placeholder": "Add user group",
      "tags": _vm.userGroupTags
    },
    on: {
      "tags-changed": function (newTags) { return _vm.userGroupTags = newTags; }
    },
    model: {
      value: (_vm.userGroupTag),
      callback: function($$v) {
        _vm.userGroupTag = $$v
      },
      expression: "userGroupTag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.email),
      expression: "value.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "email",
      "required": "",
      "id": "email",
      "placeholder": "Email Address",
      "tabindex": "5"
    },
    domProps: {
      "value": (_vm.value.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Roles")]), _vm._v(" "), _c('vue-tags-input', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "placeholder": "Add role",
      "tags": _vm.userRoles
    },
    on: {
      "tags-changed": function (newRoles) { return _vm.userRoles = newRoles; }
    },
    model: {
      value: (_vm.userRole),
      callback: function($$v) {
        _vm.userRole = $$v
      },
      expression: "userRole"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "help-block",
    attrs: {
      "id": "passwordHelpBlock"
    }
  }, [_vm._v("\n                        Available roles: User, Administrator, SuperUser, Read-Only Users, Dashboard Management\n                    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.isApproved),
      expression: "value.isApproved"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.value.isApproved) ? _vm._i(_vm.value.isApproved, null) > -1 : (_vm.value.isApproved)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value.isApproved,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.value, "isApproved", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.value, "isApproved", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.value, "isApproved", $$c)
        }
      }
    }
  }), _vm._v("\n                            Logins allowed\n                        ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onSaveClick
    }
  }, [_vm._v(" " + _vm._s(_vm.getSaveButtonText()) + "  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3f1a8e9a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f1a8e9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/accounts/user-editor.vue.html
// module id = 1095
// module chunks = 0